import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule, DialogConfig, DialogRef } from '@sag-ui';
import { SharedModule } from '../../../shared/shared.module';

@Component({
    selector: 'app-delete-user-dialog',
    standalone: true,
    imports: [CommonModule, ButtonModule, SharedModule],
    templateUrl: './delete-user.component.html'
})
export class DeleteUserDialogComponent {
    constructor(public config: DialogConfig<{ name: string }>, public dialogRef: DialogRef<string>) {}

    public onClose(result?: string): void {
        this.dialogRef.close(result);
    }
}
